/* @flow */
import * as React from 'react';

// Styles
import styles from './UpcomingBraindateCardHeader.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import { xsmall } from 'src/shared/ui/component/image/Avatar';
import { isGroupTopic } from '@braindate/domain/lib/topic/util';
import { getBraindateTopic } from 'src/shared/domain/braindate/util/braindateUtil';

// Components
import BraindateCardTags from '../BraindateCardTags';

// Types
import type { Braindate } from '@braindate/domain/lib/braindate/type';
import BraindateCardAvatar from '../BraindateCardAvatar';

const useStyles = createUseThemeStyles(styles);

type Props = {
  braindate: Braindate,
};

const UpcomingBraindateCardHeader = ({ braindate }: Props) => {
  const classes = useStyles();

  const topic = getBraindateTopic(braindate);

  return (
    <div className={classes.root}>
      <BraindateCardTags braindate={braindate} />

      {isGroupTopic(topic) && (
        <BraindateCardAvatar
          braindate={braindate}
          variant={xsmall}
          layoutClass={classes.avatar}
        />
      )}
    </div>
  );
};

export default React.memo<Props>(UpcomingBraindateCardHeader);
